import "@/index.css";
import { initSentry } from '@store-order-taking-spa-vue/instrument';
import { createApp } from 'vue'
import DeviceView from './DeviceView.vue'

setTimeout(() => {
    const app = createApp(DeviceView);
    initSentry(app);
    app.mount('#app');
});

// restart app after 12 hours
setTimeout(() => {
    window.location.reload();
}, 12 * 60 * 60 * 1000);// 12 hours
